/**
 * Date-extensions locale Norwegian Bokmål [nb]
 */
import DateExtended from "../date-extended";
DateExtended.addLocale('nb', {
    monthNames: ['Januar','Februar','Mars','April','Mai','Juni','Juli','August','September','Oktober','November','Desember'],
    monthShortNames: ['Jan.','Feb.','Mars','April','Mai','Juni','Juli','Aug.','Sep.','Okt.','Nov.','Des.'],
    dayNames: ['Søndag','Mandag','Tirsdag','Onsdag','Torsdag','Fredag','Lørdag'],
    dayShortNames: ['Sø.','Ma.','Ti.','On.','To.','Fr.','Lø.']
});
